<!-- =========================================================================================
	File Name: TheFooter.vue
	Description: Footer component
	Component Name: TheFooter
========================================================================================== -->


<template>
	<footer class="the-footer flex-wrap justify-between" :class="classes">
		<span>COPYRIGHT @ {{ getYear }} <a href="javascript:void(0);"  rel="nofollow">Smart In Out</a>, All rights Reserved</span>
		<!-- <span class="md:flex hidden items-center">
			<span>Hand-crafted & Made with</span>
			<feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
		</span> -->
	</footer>
</template>

<script>

export default {
	name: "the-footer",
	props: {
		classes: {
			type: String,
		},
	},
	data() {
		return {

		}
	},
	computed: {
		getYear() {
			let date = new Date()
			return date.getFullYear()
		}
	}
}
</script>